import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiTarget, FiShield, FiTrendingUp } = FiIcons;

const features = [
  {
    name: 'Accurate Projections',
    description: 'Based on standard 11% employee and 13% employer contribution rates with compounded dividends.',
    icon: FiTarget,
    color: 'bg-blue-50 text-blue-600'
  },
  {
    name: 'Instant Insights',
    description: 'See your retirement estimates immediately without navigating complex spreadsheets.',
    icon: FiZap,
    color: 'bg-amber-50 text-amber-600'
  },
  {
    name: 'Privacy First',
    description: 'No login required. We don\'t store your data. Your financial planning stays private to you.',
    icon: FiShield,
    color: 'bg-emerald-50 text-emerald-600'
  },
  {
    name: 'Growth Visualizer',
    description: 'Interactive charts help you visualize how your wealth accumulates over decades.',
    icon: FiTrendingUp,
    color: 'bg-indigo-50 text-indigo-600'
  },
];

const Features = () => {
  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-sm font-bold text-brand-600 uppercase tracking-[0.2em] mb-4">Value Proposition</h2>
          <p className="text-4xl font-extrabold text-slate-900 sm:text-5xl tracking-tight">Everything you need to plan ahead</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group p-8 rounded-3xl bg-white border border-slate-100 hover:border-brand-100 hover:shadow-xl hover:shadow-brand-600/5 transition-all duration-300"
            >
              <div className={`w-14 h-14 ${feature.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-sm`}>
                <SafeIcon icon={feature.icon} className="w-7 h-7" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.name}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;